module.exports = __webpack_public_path__ + "img/Officechair.40f2181f.svg";